// TonicKnowledge.js
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import 'react-datepicker/dist/react-datepicker.css';
import Loader from '../../components/utils/Loader';
import MainLayout from '../../layouts/MainLayout';
import DatePicker from 'react-datepicker';

const TonicKnowledge = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [tonicKnowledge, setTonicKnowledge] = useState([]);
  const [tonicKnowledgeName, setTonicKnowledgeName] = useState('');
  const [tonicKnowledgeLang, setTonicKnowledgeLang] = useState('English');
  const [tonicKnowledgeDate, setTonicKnowledgeDate] = useState(new Date());
  const [fetchData, { loading }] = useFetch();

  const tonicKnowledgeLangList = [
      'English',
      'French',
      'German',
      'Gujarati',
      'Hindi',
      'Italian',
      'Marathi',
      'Spanish',
  ];
  
  const tonicKnowledgeNameList = [
    "BEAT",
    "CA",
    "CAFE",
    "COAT",
    "College",
    "Commerce",
    "Cricket",
    "Chemistry",
    "Defence",
    "Engineering",
    "Entertainment",
    "Family",
    "Football",
    "JEE",
    "Law",
    "Management",
    "Maths",
    "Medcial",
    "NEET",
    "Programmer",
    "Public",
    "School",
    "Science",
    "Sports",
    "Spiritual108",
    "TOEFL",
    "Tutorials",
    "UGCNET",
    "University",
  ];


  useEffect(() => {
    document.title = authState.isLoggedIn ? `${authState.user.name}'s Tonic Knowledge` : "Think5Whys";
  }, [authState]);

  const fetchTonicKnowledge = useCallback(() => {
    const searchDate = tonicKnowledgeDate;
    searchDate.setHours(0, 0, 0, 0);
    const localDate = new Date(searchDate.getTime() - (searchDate.getTimezoneOffset() * 60000));
    const formattedDate = localDate.toISOString().split('T')[0];

    const config = {
      url: "/tonicknowledge/bydateandlang",
      method: "post",
      headers: { Authorization: authState.token },
      data: { tonicKnowledgeDate: formattedDate, tonicKnowledgeLang: tonicKnowledgeLang, tonicKnowledgeName: tonicKnowledgeName }
    };
    
    // console.log("Tonic Knowledge Payload: ", config);
  
    fetchData(config, { showSuccessToast: false })
      .then(data => {
        if (Array.isArray(data.tonicKnowledgeList)) {
          setTonicKnowledge(data.tonicKnowledgeList);
        } else {
          setTonicKnowledge([]); 
        }
      });
  }, [authState.token, fetchData, tonicKnowledgeDate, tonicKnowledgeLang, tonicKnowledgeName]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchTonicKnowledge();
  }, [authState.isLoggedIn, fetchTonicKnowledge]);

  const formatDate = (tonicKnowledgeDate) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
    };
    return new Date(tonicKnowledgeDate).toLocaleString('en-IN', options);
  };

  const sortedTonicKnowledge = [...tonicKnowledge].sort((a, b) => b.headline.localeCompare(a.headline));

  return (
    <div className='bg-black text-white [&_p]:text-white'>
      <div>
        <h2 className='text-xl font-bold text-white text-center mb-2'>Think5Whys - Tonic Knowledge Base</h2>
        
        <div className="flex flex-col mb-4 border-2 border-yellow-300 p-4 rounded-lg shadow-lg">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-6">
              <label htmlFor="tonicName" className="text-white font-medium mb-1">Select Tonic Name</label>
              <select
                id="tonicName"
                value={tonicKnowledgeName}
                onChange={(e) => setTonicKnowledgeName(e.target.value)}
                className="mt-2 p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ height: "48px" }}
              >
                <option value="">Select Tonic Name</option>
                {tonicKnowledgeNameList.map((tonicname) => (
                  <option key={tonicname} value={tonicname}>{tonicname}</option>
                ))}
              </select>
              <label htmlFor="language" className="text-white font-medium mb-1">Select Language</label>
              <select
                id="language"
                value={tonicKnowledgeLang}
                onChange={(e) => setTonicKnowledgeLang(e.target.value)}
                className="mt-2 p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ height: "48px" }}
              >
                {tonicKnowledgeLangList.map((lang) => (
                  <option key={lang} value={lang}>{lang}</option>
                ))}
              </select>
              <label htmlFor="date" className="text-white font-medium mb-1">Date</label>
              <DatePicker
                selected={tonicKnowledgeDate}
                onChange={(date) => setTonicKnowledgeDate(date)}
                className="mt-2 p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ height: "48px" }}
                dateFormat="dd-MM-yyyy"
              />
               <button
                  onClick={fetchTonicKnowledge}
                  className="bg-blue-500 text-white mt-2 p-3 hover:bg-blue-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  Get Tonic Knowledge
                </button>
            </div>
           
        </div>

        <div className="mt-4 text-yellow-200">{tonicKnowledgeName} {' Tonic - '} {tonicKnowledgeLang} {' Language for Date '}{formatDate(tonicKnowledgeDate)}</div>

        <div className="border border-gray-300 p-4 mt-4">
          <div className="mt-2">
            {tonicKnowledge && tonicKnowledge.length !== 0 && (
              sortedTonicKnowledge.map((tonicKnowledge) => (
                <div key={tonicKnowledge._id} className='bg-gray-600 my-1 p-1 text-white rounded-md shadow-md text-sm border-1'>
                  <div className='flex flex-col border-2 border-purple-500 py-2 px-4'>
                    <p className='font-medium text-yellow-200'>{tonicKnowledge.headline} </p>
                    <p
                      className="text-white"
                      dangerouslySetInnerHTML={{ __html: tonicKnowledge.brief }}
                    ></p>
                    <p className='text-green-500'>Author: {tonicKnowledge.authorName}</p>
                    <p className='text-green-500'>Source: {tonicKnowledge.infoSource}</p>
                  </div>
                </div>
              ))
            )}
          </div>

          {loading ? (
            <Loader />
          ) : (
            <div>
              {tonicKnowledge && tonicKnowledge.length === 0 && (
                <div className='min-h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                  <div className="flex justify-between items-center">
                    <h3 className='text-lg mt-1 mx-2 text-orange-400'>Recrod Not Found for {tonicKnowledgeName} {' Tonic - '} {tonicKnowledgeLang} {' Language for Date '}{formatDate(tonicKnowledgeDate)}!</h3>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TonicKnowledge;
